import React from 'react'
import './App.css'

import AppRoutes from './components/layout/AppRoutes'
import ScrollToTop from './components/layout/ScrollToTop'

function App() {
  return (
    <div>
    <ScrollToTop />
    <AppRoutes />
    </div>
  )
}

export default App